import styled from 'styled-components';
import React from 'react';
import { OptionTypeBase } from 'react-select';
import { IndicatorComponentType } from 'react-select/src/components';
import { Icon } from '@cld/icon';
import { useMixin } from '@cld/component-theme';
import { comboboxTheme } from '../theme';

const DropdownIcon = styled(Icon)`
  transition: transform 200ms ease-out;
  transform: rotate(${(props: { menuIsOpen: boolean }) => (props.menuIsOpen ? 180 : 0)}deg);
  margin-right: ${comboboxTheme.dropdownIndicator.margin.right};
`;

export const DropdownIndicator: IndicatorComponentType<OptionTypeBase> = ({ selectProps }) => {
  const color = useMixin(comboboxTheme.dropdownIndicator.color);
  return <DropdownIcon menuIsOpen={selectProps.menuIsOpen} name="arrowDropDown" size="sm" color={color} data-test-specifier='dropdown-indicator' />;
};
